import { render, staticRenderFns } from "./HeaderMenu.vue?vue&type=template&id=467c131c&scoped=true"
import script from "./HeaderMenu.vue?vue&type=script&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&lang=js"
import style0 from "./HeaderMenu.vue?vue&type=style&index=0&id=467c131c&prod&lang=css"
import style1 from "./HeaderMenu.vue?vue&type=style&index=1&id=467c131c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@osgfe/builder-plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467c131c",
  null
  
)

export default component.exports